import React, { Component } from "react";
import { TabContext, TabList, TabPanel, Alert } from "@mui/lab";
import { Box, Snackbar, Tab } from "@mui/material";
import PopinaActionCreator from "../../controller/action/PopinaActionCreator";
import PopinaRestaurant from "../../controller/model/popina/PopinaRestaurant";
import AppStore from "../../controller/store/AppStore";
import PopinaStore from "../../controller/store/PopinaStore";
import CategoryTableComponent from "./CategoryTableComponent";
import MenusTableComponent from "./MenusTableComponent";
import OptionsTableComponent from "./OptionsTableComponent";
import PaymentMethodsTableComponent from "./PaymentMethodsTableComponent";

const _updateState = () => {
  const restaurant = PopinaStore.restaurant;

  return {
    restaurant: restaurant
  };
};

interface StateInterface {
  restaurant: PopinaRestaurant | undefined;
  isLoading: boolean;
  showError: boolean;
  message: string | undefined;
  tabIndex: string;
}

class PopinaContainer extends Component {
  public state: StateInterface;
  public props: any;

  constructor(props: any) {
    super(props);
    this.state = {
      restaurant: PopinaStore.restaurant,
      isLoading: true,
      showError: false,
      message: "",
      tabIndex: "0"
    };
    this._handleStateChange = this._handleStateChange.bind(this);
    this._handleCloseSnackBar = this._handleCloseSnackBar.bind(this);
  }

  _handleStateChange() {
    this.setState(_updateState());
  }

  componentDidMount() {
    PopinaStore.addChangeListener(this._handleStateChange);
    PopinaActionCreator.fetchPopinaCarte(AppStore.establishment)
      .then(() => {
        this.setState({ isLoading: false });
      })
      .catch(err => {
        console.warn(err);
        this.setState({
          showError: true,
          message: "Erreur lors de la récupération de la carte Popina"
        });
      });
  }

  componentWillUnmount() {
    PopinaStore.removeChangeListener(this._handleStateChange);
  }

  _handleCloseSnackBar() {
    this.setState({ showError: false, message: "" });
  }

  handleTabChange = (event: React.ChangeEvent<{}>, index: any) => {
    this.setState({ tabIndex: index });
  };

  render() {
    return (
      <div style={{ width: "100%", height: "100%" }}>
        <Snackbar
          open={this.state.showError}
          autoHideDuration={6000}
          onClose={this._handleCloseSnackBar}
        >
          <Alert severity="error" onClose={this._handleCloseSnackBar}>
            {this.state.message}
          </Alert>
        </Snackbar>

        {this.state.restaurant !== undefined ? (
          <TabContext value={this.state.tabIndex}>
            <Box style={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList
                onChange={this.handleTabChange}
              >
                <Tab label="Produits" value="0" />
                <Tab label="Options" value="1" />
                <Tab label="Menus" value="2" />
                <Tab label="Modes de paiement" value="3" />
              </TabList>
            </Box>
            <TabPanel value="0" style={{padding:"10px 0"}}>
              <CategoryTableComponent restaurant={this.state.restaurant} />
            </TabPanel>
            <TabPanel value="1" style={{padding:"10px 0"}}>
              <OptionsTableComponent restaurant={this.state.restaurant} />
            </TabPanel>
            <TabPanel value="2" style={{padding:"10px 0"}}>
              <MenusTableComponent restaurant={this.state.restaurant}/>
            </TabPanel>
            <TabPanel value="3" style={{padding:"10px 0"}}>
              <PaymentMethodsTableComponent restaurant={this.state.restaurant}/>
            </TabPanel>
          </TabContext>
        ) : (
          <div />
        )}
      </div>
    );
  }
}

export default PopinaContainer;
